// Apartment Images - User provided
export const apartmentImages = [
  {
    id: 1,
    src: "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/32akl3gp_20251214_190605.jpg",
    alt: "Spavaća soba s krevetom"
  },
  {
    id: 2,
    src: "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/aeu9ce1q_20251214_184946.jpg",
    alt: "Moderno kupatilo"
  },
  {
    id: 3,
    src: "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/dg9dm5lg_20251214_185256.jpg",
    alt: "Opremljena kuhinja"
  },
  {
    id: 4,
    src: "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/vyy1dw9z_20251214_185357.jpg",
    alt: "Dnevni boravak sa Smart TV"
  },
  {
    id: 5,
    src: "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/2b6mefga_20251214_190556.jpg",
    alt: "Spavaća soba - pogled"
  },
  {
    id: 6,
    src: "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/v1vzdoaa_20251214_190605.jpg",
    alt: "Spavaća soba - detalj"
  }
];

// Hero images
export const heroImages = [
  "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/k3o4fnm2_image.png",
  "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/32akl3gp_20251214_190605.jpg"
];

// Attractions data
export const attractions = [
  {
    id: 1,
    name: "Baščaršija",
    description: "Srce Sarajeva - historijski bazar s autentičnim zanatskim radnjama, tradicionalnim kafama i Sebiljem. Prošetajte kaldrmanim ulicama, probajte ćevape i bosansku kafu, te uživajte u jedinstvenoj atmosferi Starog grada.",
    distance: "15 min hoda",
    images: [
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/7jdgxv4j_image.png",
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/pwpvotrq_image.png",
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/heer8f6q_image.png"
    ]
  },
  {
    id: 2,
    name: "Raskrižje vjera i kultura",
    description: "Sarajevo je stoljećima poznato kao mjesto susreta religija, gdje se na malom prostoru susreću crkve, džamije i sinagoge. U njegovoj povijesti isprepliću se katolička, islamska, pravoslavna i židovska tradicija, stvarajući jedinstven kulturni i duhovni mozaik. Upravo ta raznolikost daje gradu poseban identitet i simboliku suživota različitih vjera i naroda.",
    distance: "2 min hoda",
    images: [
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/8gcepaw9_image.png",
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/w5lt4utf_image.png",
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/coth54u3_image.png"
    ]
  },
  {
    id: 3,
    name: "Vijećnica",
    description: "Simbolička građevina Sarajeva u pseudo-maurskom stilu. Obnovljena nakon rata, danas je kulturni centar i domaćin brojnih izložbi i koncerata. Noću je posebno impresivna zahvaljujući rasvjeti.",
    distance: "12 min hoda",
    images: [
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/chdjinng_image.png",
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/hdgtnbmq_image.png",
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/3qdygrtz_image.png"
    ]
  },
  {
    id: 4,
    name: "Trebević",
    description: "Planina koja nadvisuje Sarajevo s olimpijskom bobsled stazom. Žičarom se za samo 10 minuta popnete na vrh s predivnim pogledom na grad. Idealno za planinarenje, zip-line i uživanje u prirodi.",
    distance: "20 min hoda do žičare",
    images: [
      "https://images.unsplash.com/photo-1694551351580-e3d17e363478",
      "https://images.pexels.com/photos/18714730/pexels-photo-18714730.jpeg",
      "https://images.unsplash.com/photo-1746588592126-20dd61ecb11d"
    ]
  },
  {
    id: 5,
    name: "Vrelo Bosne",
    description: "Izvor rijeke Bosne okružen prekrasnim parkom - savršeno mjesto za bijeg od gradske vreve. Šetnja alejom platana, vožnja fijakerom i uživanje u kristalno čistoj vodi ostavit će vas bez daha.",
    distance: "20 min autom",
    images: [
      "https://images.unsplash.com/photo-1761618527361-760b95ad8416",
      "https://images.unsplash.com/photo-1761475155575-50db8fc477a6",
      "https://images.pexels.com/photos/35309968/pexels-photo-35309968.jpeg"
    ]
  },
  {
    id: 6,
    name: "Latinska ćuprija",
    description: "Historijski most na rijeci Miljacki, poznat kao mjesto atentata na Franza Ferdinanda 1914. godine. Muzej posvećen ovom događaju nalazi se u neposrednoj blizini.",
    distance: "10 min hoda",
    images: [
      "https://images.unsplash.com/photo-1706233385855-8153b12194dc",
      "https://images.unsplash.com/photo-1720060981076-eecb0cce3a20",
      "https://images.pexels.com/photos/20813448/pexels-photo-20813448.jpeg"
    ]
  },
  {
    id: 7,
    name: "Između znamenitosti i prirodnih ljepota",
    description: "Sarajevo nudi savršen spoj urbane arhitekture i netaknute prirode. Od impozantne Vijećnice i historijske Latinske ćuprije, do kristalno čistih izvora i spektakularnih vodopada - sve je nadohvat ruke. Istražite bogatstvo koje ovaj grad i njegova okolica nude.",
    distance: "U krugu od 30 min",
    images: [
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/bs3fa5o1_image.png",
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/3wzqy5uz_image.png",
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/6wycvng6_image.png",
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/ge07whxk_image.png"
    ]
  }
];

// FAQ data
export const faqData = [
  {
    question: "Koje je vrijeme prijave i odjave?",
    answer: "Prijava (check-in) je moguća od 14:00, a odjava (check-out) do 10:00. U slučaju potrebe, molimo kontaktirajte nas za prilagodbu termina."
  },
  {
    question: "Da li mogu dovesti kućnog ljubimca?",
    answer: "Nažalost, kućni ljubimci nisu dozvoljeni u apartmanu."
  },
  {
    question: "Da li apartman ima parking?",
    answer: "Da, apartman nudi besplatno privatno parkirno mjesto."
  },
  {
    question: "Da li je dozvoljeno pušenje?",
    answer: "Pušenje nije dozvoljeno unutar apartmana. Za pušenje je predviđen prostor ispred zgrade."
  },
  {
    question: "Koliki je kapacitet apartmana?",
    answer: "Apartman može primiti do 2 odrasle osobe + dijete."
  }
];

// Amenities data
export const amenities = [
  { icon: "Wifi", label: "Besplatan WiFi" },
  { icon: "Thermometer", label: "Klima uređaj" },
  { icon: "Flame", label: "Grijanje" },
  { icon: "Car", label: "Parking" },
  { icon: "Tv", label: "Smart TV" },
  { icon: "TreePine", label: "Pogled na park" }
];

// Contact info
export const contactInfo = {
  phone: "+387 63 894 069",
  email: "janecek_i@hotmail.com",
  whatsapp: "+38763894069",
  address: "Koševo 21, 71000 Sarajevo, BiH"
};

// Apartment info
export const apartmentInfo = {
  name: "Sarajevo City Center Apartment",
  subtitle: "near Presidency",
  tagline: "Smještaj u srcu Sarajeva s pogledom na park",
  description: "Potpuno nov apartman s novom opremom i namještajem u samom centru Sarajeva. Gosti mogu uživati u modernom interijeru i svim pogodnostima za ugodan boravak. Apartman ima klimu, privatno kupatilo s besplatnim toaletnim potrepštinama i potpuno opremljenu kuhinju. Dodatne pogodnosti uključuju veliku dnevnu sobu sa Smart TV-om, Smart TV u spavaćoj sobi, grijanje i besplatni WiFi. Na raspolaganju je i privatno parkirno mjesto.",
  capacity: "2 odrasle osobe + dijete",
  googleMapsUrl: "https://www.google.com/maps/search/?api=1&query=Ko%C5%A1evo%2021%2C%20Sarajevo%2C%20BiH",
  bookingUrl: "https://www.booking.com/hotel/ba/town-place-sarajevo-center-presidency.hr.html#tab-reviews"
};